import { Component, inject, input, output } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ImagesService } from '../../../../services/general/images.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanRepaymentDto } from '../../../../interfaces/responses/loan.interface';
import { ProductDetailsStore } from '../../../../pages/products/product-details/product-details.store';
import { PermissionService } from '../../../../services/permission/permission.service';

@Component({
  selector: 'app-single-product-repayment-table',
  imports: [CommonModule, DatePipe],
  templateUrl: './single-product-repayment-table.component.html',
  styleUrl: './single-product-repayment-table.component.scss'
})
export class SingleProductRepaymentTableComponent {
  _images = inject(ImagesService);
  _router = inject(Router);
  route = inject(ActivatedRoute);
  private productDetailsStore = inject(ProductDetailsStore);
  permissionService = inject(PermissionService);

  repayment = input.required<LoanRepaymentDto>();
  productId = input<string>();

  onDelete = output<string>();

  get applicantName(): string {
    const user = this.repayment().loan?.user;
    if (!user) return '—';
    return `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
  }

  get initials(): string {
    const user = this.repayment().loan?.user;
    if (!user) return '?';
    const first = user.firstName?.[0] ?? '';
    const last = user.lastName?.[0] ?? '';
    return (first + last).toUpperCase() || '?';
  }

  get loanStatus(): string {
    return (this.repayment().loan?.status ?? '').toLowerCase();
  }

  triggerDelete(event: Event): void {
    event.stopPropagation();
    this.onDelete.emit(this.repayment().id);
  }

  onViewClick(): void {
    const loan = this.repayment().loan;
    const loanId = loan?.id;
    const prodId = this.productId();
    if (!loanId || !prodId) return;
    this.productDetailsStore.setSelectedLoan(loan);
    this._router.navigate([`/product-details/${prodId}/applicant/${loanId}`]);
  }
}
